export const returnCityZipCodesByState = state => {
  if (state === "VT") {
    return VT_CITY_ZIP_CODES;
  } else if (state === "NH") {
    return NH_CITY_ZIP_CODES;
  } else {
    return VT_CITY_ZIP_CODES;
  }
};

export const VT_CITY_ZIP_CODES = {
  Addison: "05491",
  Adamant: "05640",
  Albany: "05820",
  Alburgh: "05440",
  Andover: "05143",
  Arlington: "05250",
  Ascutney: "05030",
  Athens: "05143",
  Averill: "05901",
  "Avery's Gore": "",
  Bakersfield: "05441",
  Baltimore: "05143",
  Barnard: "05031",
  Barnet: "05821",
  "Barre City": "05641",
  "Barre Town": "05641,05649,05654,05670,05678",
  Barton: "05822,05875",
  "Beebe Plain": "05823",
  "Beecher Falls": "05902",
  "Bellows Falls": "05101",
  Belmont: "05730",
  Belvidere: "05442",
  "Belvidere Center": "05442",
  Bennington: "05201",
  Benson: "05731,05743,05760",
  Berkshire: "05447",
  Berlin: "05602,05641",
  Bethel: "05032",
  Bloomfield: "05905",
  Bomoseen: "05732",
  Bondville: "05340",
  Bolton: "05465,05466,05676,05477",
  Bradford: "05033",
  Braintree: "05060",
  Brandon: "05733",
  Brattleboro: "05301,05302,05303,05304",
  Bridgewater: "05034",
  "Bridgewater Corners": "05035",
  Bridport: "05734",
  Brighton: "05846",
  Bristol: "05443",
  Brookfield: "05036",
  Brookline: "05345",
  Brownington: "05860",
  Brownsville: "05037",
  Brunswick: "05905",
  "Buel's Gore": "",
  Burke: "05871",
  Burlington: "05401,05402,05405,05406,05408",
  Cabot: "05647",
  Calais: "05648",
  Cambridge: "05444",
  Cambridgeport: "05141",
  Canaan: "05903",
  Castleton: "05735",
  Cavendish: "05142",
  "Center Rutland": "05736",
  Charleston: "05833,05872",
  Charlotte: "05445",
  Chelsea: "05038",
  Chester: "05143",
  "Chester Depot": "05144",
  Chittenden: "05737",
  Clarendon: "05759",
  Colchester: "05439,05446,05449",
  Concord: "05824",
  Corinth: "05039",
  Cornwall: "05753",
  Coventry: "05825",
  Craftsbury: "05826",
  "Craftsbury Common": "05827",
  Cuttingsville: "05738",
  Danby: "05739",
  Danville: "05828",
  Derby: "05829",
  "Derby Line": "05830",
  Dorset: "05251",
  Dover: "05341,05351,05355,05356,05363",
  Dummerston: "05301",
  Duxbury: "05676",
  "East Arlington": "05252",
  "East Barre": "05649",
  "East Berkshire": "05447",
  "East Burke": "05832",
  "East Calais": "05650",
  "East Charleston": "05833",
  "East Corinth": "05040",
  "East Dorset": "05253",
  "East Dover": "05341",
  "East Fairfield": "05448",
  "East Hardwick": "05836",
  "East Haven": "05837",
  "East Middlebury": "05740",
  "East Montpelier": "05651",
  "East Poultney": "05741",
  "East Randolph": "05041",
  "East Ryegate": "05042",
  "East Saint Johnsbury": "05838",
  "East Thetford": "05043",
  "East Wallingford": "05742",
  Eden: "05652",
  "Eden Mills": "05653",
  Elmore: "05657",
  "Enosburg Falls": "05450",
  Enosburgh: "05450",
  Essex: "05451,05452",
  "Essex Junction": "05452,05453,05479",
  "Fair Haven": "05743",
  Fairfax: "05454",
  Fairfield: "05455",
  Fairlee: "05045",
  Fayston: "05660,05673",
  Ferdinand: "05905",
  Ferrisburgh: "05456",
  Fletcher: "",
  Florence: "05744",
  "Forest Dale": "05745",
  Franklin: "05457",
  Gaysville: "05746",
  Georgia: "05454,05468,05478",
  Gilman: "05904",
  Glastenbury: "",
  Glover: "05839",
  Goshen: "05733",
  Grafton: "05146",
  Granby: "05840",
  "Grand Isle": "05458",
  Graniteville: "05654",
  Granville: "05747",
  Greensboro: "05841",
  "Greensboro Bend": "05842",
  Groton: "05046",
  Guildhall: "05905",
  Guilford: "05301",
  Halifax: "05358",
  Hancock: "05748",
  Hardwick: "05843",
  Hartford: "05047",
  Hartland: "05048",
  "Hartland Four Corners": "05049",
  Highgate: "05459",
  "Highgate Center": "05459",
  "Highgate Springs": "05460",
  Hinesburg: "05461",
  Holland: "05830",
  Hubbardton: "05735,05743",
  Huntington: "05462",
  "Hyde Park": "05655",
  Hydeville: "05750",
  Ira: "05777",
  Irasburg: "05845",
  "Island Pond": "05846",
  "Isle La Motte": "05463",
  Jacksonville: "05342",
  Jamaica: "05343",
  Jay: "05859",
  Jeffersonville: "05464",
  Jericho: "05465",
  Johnson: "05656",
  Jonesville: "05466",
  Killington: "05751",
  Kirby: "05824",
  "Lake Elmore": "05657",
  Landgrove: "05152",
  Leicester: "05733",
  Lemington: "05903,05905",
  Lewis: "05846",
  Lincoln: "05443",
  Londonderry: "05148",
  Lowell: "05847",
  "Lower Waterford": "05848",
  Ludlow: "05149",
  Lunenburg: "05906",
  Lyndon: "05849,05850",
  "Lyndon Center": "05850",
  Lyndonville: "05851",
  Maidstone: "05905",
  Manchester: "05254",
  "Manchester Center": "05255",
  Marlboro: "05344",
  Marshfield: "05658",
  "McIndoe Falls": "05050",
  Mendon: "05701",
  Middlebury: "05753",
  Middlesex: "05602",
  "Middletown Springs": "05757",
  Milton: "05468",
  Monkton: "05469",
  Montgomery: "05470,05471",
  "Montgomery Center": "05471",
  Montpelier: "05601,05602,05603,05604,05609,05620,05633",
  Moretown: "05660",
  Morgan: "05853",
  Morristown: "05661",
  Morrisville: "05661",
  Moscow: "05662",
  "Mount Holly": "05758",
  "Mount Tabor": "05739",
  "New Haven": "05472",
  Newark: "05871",
  Newbury: "05051",
  Newfane: "05345",
  Newport: "05855",
  "Newport Center": "05857",
  "Newport Town": "05857",
  "North Bennington": "05257",
  "North Clarendon": "05759",
  "North Concord": "05858",
  "North Ferrisburgh": "05473",
  "North Hartland": "05052",
  "North Hero": "05474",
  "North Hyde Park": "05665",
  "North Montpelier": "05666",
  "North Pomfret": "05053",
  "North Pownal": "05260",
  "North Springfield": "05150",
  "North Thetford": "05054",
  "North Troy": "05859",
  Northfield: "05663",
  "Northfield Falls": "05664",
  Norton: "05907",
  Norwich: "05055",
  Orange: "05641,05649",
  Orleans: "05860",
  Orwell: "05760",
  Panton: "05491",
  Passumpsic: "05861",
  Pawlet: "05761",
  Peacham: "05862",
  Perkinsville: "05151",
  Peru: "05152",
  Pittsfield: "05762",
  Pittsford: "05763",
  Plainfield: "05667",
  Plymouth: "05056",
  Pomfret: "05053,05067",
  "Post Mills": "05058",
  Poultney: "05764",
  Pownal: "05261",
  Proctor: "05765",
  Proctorsville: "05153",
  Putney: "05346",
  Quechee: "05059",
  Randolph: "05060",
  "Randolph Center": "05061",
  Reading: "05062",
  Readsboro: "05350",
  Richford: "05476",
  Richmond: "05477",
  Ripton: "05766",
  Rochester: "05767",
  Rockingham: "",
  Roxbury: "05669",
  Royalton: "05068",
  Rupert: "05768,05776",
  Rutland: "05701,05702",
  "Rutland Town": "05701",
  Ryegate: "05042,05069",
  "Saint Albans": "05478",
  "Saint Albans Bay": "05481",
  "Saint Albans Town": "05478",
  "Saint George": "05495",
  "Saint Johnsbury": "05819",
  "Saint Johnsbury Center": "05863",
  Salisbury: "05769",
  Sandgate: "05250",
  "Saxtons River": "05154",
  Searsburg: "05201",
  Shaftsbury: "05262",
  Sharon: "05065",
  Sheffield: "05866",
  Shelburne: "05482",
  Sheldon: "05483",
  "Sheldon Springs": "05485",
  Shoreham: "05770",
  Shrewsbury: "05738",
  Somerset: "05201",
  "South Barre": "05670",
  "South Burlington": "05403,05407",
  "South Hero": "05486",
  "South Londonderry": "05155",
  "South Newfane": "05351",
  "South Pomfret": "05067",
  "South Royalton": "05068",
  "South Ryegate": "05069",
  "South Strafford": "05070",
  "South Woodstock": "05071",
  Springfield: "05156",
  Stamford: "05352",
  Stannard: "05842",
  Starksboro: "05487",
  Stockbridge: "05772",
  Stowe: "05672",
  Strafford: "05072",
  Stratton: "05360",
  Sudbury: "05733",
  Sunderland: "05250,05252",
  Sutton: "05867",
  Swanton: "05488",
  Taftsville: "05073",
  Thetford: "05074,05075",
  "Thetford Center": "05075",
  Tinmouth: "05773",
  Topsham: "05076",
  Townshend: "05353",
  Troy: "05868",
  Tunbridge: "05077",
  Underhill: "05489",
  "Underhill Center": "05490",
  Vergennes: "05491",
  Vernon: "05354",
  Vershire: "05079",
  Victory: "05858",
  Waitsfield: "05673",
  Walden: "05873",
  Wallingford: "05773",
  Waltham: "05491",
  Wardsboro: "05355",
  "Warner's Grant": "",
  Warren: "05674",
  "Warren's Gore": "",
  Washington: "05675",
  Waterbury: "05671,05676",
  "Waterbury Center": "05677",
  Waterford: "05819",
  Waterville: "05492",
  Weathersfield: "05156",
  Websterville: "05678",
  Wells: "05774",
  "Wells River": "05081",
  "West Burke": "05871",
  "West Charleston": "05872",
  "West Danville": "05873",
  "West Dover": "05356",
  "West Dummerston": "05357",
  "West Fairlee": "05083",
  "West Halifax": "05358",
  "West Hartford": "05084",
  "West Haven": "05743",
  "West Newbury": "05085",
  "West Pawlet": "05775",
  "West Rupert": "05776",
  "West Rutland": "05777",
  "West Topsham": "05086",
  "West Townshend": "05359",
  "West Wardsboro": "05360",
  "West Windsor": "05089",
  Westfield: "05874",
  Westford: "05494",
  Westminster: "05158",
  "Westminster Station": "05159",
  Westmore: "05822,05860",
  Weston: "05161",
  Weybridge: "05753",
  Wheelock: "05851",
  "White River Junction": "05001,05009",
  Whiting: "05778",
  Whitingham: "05361",
  Wilder: "05088",
  Williamstown: "05679",
  Williamsville: "05362",
  Williston: "05495",
  Wilmington: "05363",
  Windham: "05359",
  Windsor: "05089",
  Winhall: "05340",
  Winooski: "05404",
  Wolcott: "05680",
  Woodbury: "05681",
  Woodford: "05201",
  Woodstock: "05091",
  Worcester: "05682",
};
const NH_CITY_ZIP_CODES = {
  Acworth: "03601",
  Alstead: "03602",
  Alton: "03809",
  "Alton Bay": "03810",
  Amherst: "03031",
  Andover: "03216",
  Antrim: "03440",
  Ashland: "03217",
  Ashuelot: "03441",
  Atkinson: "03811",
  Auburn: "03032",
  Barnstead: "03218",
  Barrington: "03825",
  Bartlett: "03812",
  Bath: "03740",
  Bedford: "03110",
  Belmont: "03220",
  Bennington: "03442",
  Berlin: "03570",
  Bethlehem: "03574",
  Bow: "03304",
  Bradford: "03221",
  "Bretton Woods": "03575",
  Bristol: "03222",
  Brookline: "03033",
  Campton: "03223",
  Canaan: "03741",
  Candia: "03034",
  Canterbury: "03224",
  "Center Barnstead": "03225",
  "Center Conway": "03813",
  "Center Harbor": "03226",
  "Center Ossipee": "03814",
  "Center Sandwich": "03227",
  "Center Strafford": "03815",
  "Center Tuftonboro": "03816",
  Charlestown: "03603",
  Chester: "03036",
  Chesterfield: "03443",
  Chichester: "03258",
  Chocorua: "03817",
  Claremont: "03743",
  Colebrook: "03576",
  Concord: "03301,03302,03303,03305",
  Contoocook: "03229",
  Conway: "03818",
  Cornish: "03745",
  "Cornish Flat": "03746",
  Danbury: "03230",
  Danville: "03819",
  Deerfield: "03037",
  Derry: "03038",
  Dover: "03820,03821,03822",
  Drewsville: "03604",
  Dublin: "03444",
  Dunbarton: "03046",
  Durham: "03824",
  "East Andover": "03231",
  "East Candia": "03040",
  "East Derry": "03041",
  "East Hampstead": "03826",
  "East Kingston": "03827",
  "East Wakefield": "03830",
  "Eaton Center": "03832",
  Effingham: "03882",
  Elkins: "03233",
  Enfield: "03748",
  "Enfield Center": "03749",
  Epping: "03042",
  Epsom: "03234",
  Errol: "03579",
  Etna: "03750",
  Exeter: "03833",
  Farmington: "03835",
  Fitzwilliam: "03447",
  Francestown: "03043",
  Franconia: "03580",
  Franklin: "03235",
  Freedom: "03836",
  Fremont: "03044",
  "Georges Mills": "03751",
  Gilford: "03249",
  Gilmanton: "03237",
  "Gilmanton Iron Works": "03837",
  Gilsum: "03448",
  Glen: "03838",
  Glencliff: "03238",
  Goffstown: "03045",
  Gorham: "03581",
  Goshen: "03752",
  Grafton: "03240",
  Grantham: "03753",
  Greenfield: "03047",
  Greenland: "03840",
  Greenville: "03048",
  Groveton: "03582",
  Guild: "03754",
  Hampstead: "03841",
  Hampton: "03842,03843",
  "Hampton Falls": "03844",
  Hancock: "03449",
  Hanover: "03755",
  Harrisville: "03450",
  Haverhill: "03765",
  Hebron: "03241",
  Henniker: "03242",
  Hill: "03243",
  Hillsborough: "03244",
  Hinsdale: "03451",
  Holderness: "03245",
  Hollis: "03049",
  Hooksett: "03106",
  Hudson: "03051",
  Intervale: "03845",
  Jackson: "03846",
  Jaffrey: "03452",
  Jefferson: "03583",
  Kearsarge: "03847",
  Keene: "03431,03435",
  Kingston: "03848",
  Laconia: "03246,03247",
  Lancaster: "03584",
  Lebanon: "03756,03766",
  Lee: "03861",
  Lempster: "03605",
  Lincoln: "03251",
  Lisbon: "03585",
  Litchfield: "03052",
  Littleton: "03561",
  Lochmere: "03252",
  Londonderry: "03053",
  Loudon: "03307",
  Lyme: "03768",
  "Lyme Center": "03769",
  Lyndeborough: "03082",
  Madbury: "03823",
  Madison: "03849",
  Manchester: "03101,03102,03103,03104,03105,03107,03108,03109,03111",
  Marlborough: "03455",
  Marlow: "03456",
  "Melvin Village": "03850",
  Meredith: "03253",
  Meriden: "03770",
  Merrimack: "03054",
  Milan: "03588",
  Milford: "03055",
  Milton: "03851",
  "Milton Mills": "03852",
  "Mirror Lake": "03853",
  Monroe: "03771",
  "Mont Vernon": "03057",
  Moultonborough: "03254",
  "Mount Washington": "03589",
  Nashua: "03060,03061,03062,03063,03064",
  Nelson: "03457",
  "New Boston": "03070",
  "New Castle": "03854",
  "New Durham": "03855",
  "New Hampton": "03256",
  "New Ipswich": "03071",
  "New London": "03257",
  Newbury: "03255",
  Newfields: "03856",
  Newington: "03805",
  Newmarket: "03857",
  Newport: "03773",
  Newton: "03858",
  "Newton Junction": "03859",
  "North Conway": "03860",
  "North Hampton": "03862",
  "North Haverhill": "03774",
  "North Salem": "03073",
  "North Sandwich": "03259",
  "North Stratford": "03590",
  "North Sutton": "03260",
  "North Walpole": "03609",
  "North Woodstock": "03262",
  Northwood: "03261",
  Nottingham: "03290",
  Orford: "03777",
  Ossipee: "03864",
  Pelham: "03076",
  Peterborough: "03458",
  Piermont: "03779",
  Pike: "03780",
  Pittsburg: "03592",
  Pittsfield: "03263",
  Plainfield: "03781",
  Plaistow: "03865",
  Plymouth: "03264",
  Portsmouth: "03801,03802,03803,03804",
  Randolph: "03593",
  Raymond: "03077",
  Rindge: "03461",
  Rochester: "03839,03866,03867,03868",
  Rollinsford: "03869",
  Rumney: "03266",
  Rye: "03870",
  "Rye Beach": "03871",
  Salem: "03079",
  Salisbury: "03268",
  Sanbornton: "03269",
  Sanbornville: "03872",
  Sandown: "03873",
  Seabrook: "03874",
  "Silver Lake": "03875",
  Somersworth: "03878",
  "South Acworth": "03607",
  "South Newbury": "03272",
  "South Sutton": "03273",
  "South Tamworth": "03883",
  Spofford: "03462",
  Springfield: "03284",
  "Stinson Lake": "03274",
  Stoddard: "03464",
  Strafford: "03884",
  Stratham: "03885",
  "Sugar Hill": "03586",
  Sullivan: "03445",
  Sunapee: "03782",
  Suncook: "03275",
  Swanzey: "03446",
  Tamworth: "03886",
  Temple: "03084",
  Thornton: "03285",
  Tilton: "03276,03298,03299",
  Troy: "03465",
  "Twin Mountain": "03595",
  Union: "03887",
  Walpole: "03608",
  Warner: "03278",
  Warren: "03279",
  Washington: "03280",
  "Waterville Valley": "03215",
  Weare: "03281",
  Wentworth: "03282",
  "West Chesterfield": "03466",
  "West Lebanon": "03784",
  "West Nottingham": "03291",
  "West Ossipee": "03890",
  "West Peterborough": "03468",
  "West Stewartstown": "03597",
  "West Swanzey": "03469",
  Westmoreland: "03467",
  Whitefield: "03598",
  Wilmot: "03287",
  Wilton: "03086",
  Winchester: "03470",
  Windham: "03087",
  Winnisquam: "03289",
  Wolfeboro: "03894",
  "Wolfeboro Falls": "03896",
  Wonalancet: "03897",
  Woodstock: "03293",
  Woodsville: "03785",
};
export { NH_ZIP_CODE_CITIES, NH_CITY_ZIP_CODES };
const NH_ZIP_CODE_CITIES = {
  "03031": "Amherst",
  "03032": "Auburn",
  "03033": "Brookline",
  "03034": "Candia",
  "03036": "Chester",
  "03037": "Deerfield",
  "03038": "Derry",
  "03040": "East Candia",
  "03041": "East Derry",
  "03042": "Epping",
  "03043": "Francestown",
  "03044": "Fremont",
  "03045": "Goffstown",
  "03046": "Dunbarton",
  "03047": "Greenfield",
  "03048": "Greenville",
  "03049": "Hollis",
  "03051": "Hudson",
  "03052": "Litchfield",
  "03053": "Londonderry",
  "03054": "Merrimack",
  "03055": "Milford",
  "03057": "Mont Vernon",
  "03060": "Nashua",
  "03061": "Nashua",
  "03062": "Nashua",
  "03063": "Nashua",
  "03064": "Nashua",
  "03070": "New Boston",
  "03071": "New Ipswich",
  "03073": "North Salem",
  "03076": "Pelham",
  "03077": "Raymond",
  "03079": "Salem",
  "03082": "Lyndeborough",
  "03084": "Temple",
  "03086": "Wilton",
  "03087": "Windham",
  "03101": "Manchester",
  "03102": "Manchester",
  "03103": "Manchester",
  "03104": "Manchester",
  "03105": "Manchester",
  "03106": "Hooksett",
  "03107": "Manchester",
  "03108": "Manchester",
  "03109": "Manchester",
  "03110": "Bedford",
  "03111": "Manchester",
  "03215": "Waterville Valley",
  "03216": "Andover",
  "03217": "Ashland",
  "03218": "Barnstead",
  "03220": "Belmont",
  "03221": "Bradford",
  "03222": "Bristol",
  "03223": "Campton",
  "03224": "Canterbury",
  "03225": "Center Barnstead",
  "03226": "Center Harbor",
  "03227": "Center Sandwich",
  "03229": "Contoocook",
  "03230": "Danbury",
  "03231": "East Andover",
  "03233": "Elkins",
  "03234": "Epsom",
  "03235": "Franklin",
  "03237": "Gilmanton",
  "03238": "Glencliff",
  "03240": "Grafton",
  "03241": "Hebron",
  "03242": "Henniker",
  "03243": "Hill",
  "03244": "Hillsborough",
  "03245": "Holderness",
  "03246": "Laconia",
  "03247": "Laconia",
  "03249": "Gilford",
  "03251": "Lincoln",
  "03252": "Lochmere",
  "03253": "Meredith",
  "03254": "Moultonborough",
  "03255": "Newbury",
  "03256": "New Hampton",
  "03257": "New London",
  "03258": "Chichester",
  "03259": "North Sandwich",
  "03260": "North Sutton",
  "03261": "Northwood",
  "03262": "North Woodstock",
  "03263": "Pittsfield",
  "03264": "Plymouth",
  "03266": "Rumney",
  "03268": "Salisbury",
  "03269": "Sanbornton",
  "03272": "South Newbury",
  "03273": "South Sutton",
  "03274": "Stinson Lake",
  "03275": "Suncook",
  "03276": "Tilton",
  "03278": "Warner",
  "03279": "Warren",
  "03280": "Washington",
  "03281": "Weare",
  "03282": "Wentworth",
  "03284": "Springfield",
  "03285": "Thornton",
  "03287": "Wilmot",
  "03289": "Winnisquam",
  "03290": "Nottingham",
  "03291": "West Nottingham",
  "03293": "Woodstock",
  "03298": "Tilton",
  "03299": "Tilton",
  "03301": "Concord",
  "03302": "Concord",
  "03303": "Concord",
  "03304": "Bow",
  "03305": "Concord",
  "03307": "Loudon",
  "03431": "Keene",
  "03435": "Keene",
  "03440": "Antrim",
  "03441": "Ashuelot",
  "03442": "Bennington",
  "03443": "Chesterfield",
  "03444": "Dublin",
  "03445": "Sullivan",
  "03446": "Swanzey",
  "03447": "Fitzwilliam",
  "03448": "Gilsum",
  "03449": "Hancock",
  "03450": "Harrisville",
  "03451": "Hinsdale",
  "03452": "Jaffrey",
  "03455": "Marlborough",
  "03456": "Marlow",
  "03457": "Nelson",
  "03458": "Peterborough",
  "03461": "Rindge",
  "03462": "Spofford",
  "03464": "Stoddard",
  "03465": "Troy",
  "03466": "West Chesterfield",
  "03467": "Westmoreland",
  "03468": "West Peterborough",
  "03469": "West Swanzey",
  "03470": "Winchester",
  "03561": "Littleton",
  "03570": "Berlin",
  "03574": "Bethlehem",
  "03575": "Bretton Woods",
  "03576": "Colebrook",
  "03579": "Errol	,207",
  "03580": "Franconia",
  "03581": "Gorham",
  "03582": "Groveton",
  "03583": "Jefferson",
  "03584": "Lancaster",
  "03585": "Lisbon",
  "03586": "Sugar Hill",
  "03588": "Milan",
  "03589": "Mount Washington",
  "03590": "North Stratford",
  "03592": "Pittsburg",
  "03593": "Randolph",
  "03595": "Twin Mountain",
  "03597": "West Stewartstown",
  "03598": "Whitefield",
  "03601": "Acworth",
  "03602": "Alstead",
  "03603": "Charlestown",
  "03604": "Drewsville",
  "03605": "Lempster",
  "03607": "South Acworth",
  "03608": "Walpole",
  "03609": "North Walpole",
  "03740": "Bath",
  "03741": "Canaan",
  "03743": "Claremont",
  "03745": "Cornish",
  "03746": "Cornish Flat",
  "03748": "Enfield",
  "03749": "Enfield Center",
  "03750": "Etna",
  "03751": "Georges Mills",
  "03752": "Goshen",
  "03753": "Grantham",
  "03754": "Guild",
  "03755": "Hanover",
  "03756": "Lebanon",
  "03765": "Haverhill",
  "03766": "Lebanon",
  "03768": "Lyme",
  "03769": "Lyme Center",
  "03770": "Meriden",
  "03771": "Monroe",
  "03773": "Newport",
  "03774": "North Haverhill",
  "03777": "Orford",
  "03779": "Piermont",
  "03780": "Pike",
  "03781": "Plainfield",
  "03782": "Sunapee",
  "03784": "West Lebanon",
  "03785": "Woodsville",
  "03801": "Portsmouth",
  "03802": "Portsmouth",
  "03803": "Portsmouth",
  "03804": "Portsmouth",
  "03805": "Newington",
  "03809": "Alton",
  "03810": "Alton Bay",
  "03811": "Atkinson",
  "03812": "Bartlett",
  "03813": "Center Conway",
  "03814": "Center Ossipee",
  "03815": "Center Strafford",
  "03816": "Center Tuftonboro",
  "03817": "Chocorua",
  "03818": "Conway",
  "03819": "Danville",
  "03820": "Dover",
  "03821": "Dover",
  "03822": "Dover",
  "03823": "Madbury",
  "03824": "Durham",
  "03825": "Barrington",
  "03826": "East Hampstead",
  "03827": "East Kingston",
  "03830": "East Wakefield",
  "03832": "Eaton Center",
  "03833": "Exeter",
  "03835": "Farmington",
  "03836": "Freedom",
  "03837": "Gilmanton Iron Works",
  "03838": "Glen",
  "03839": "Rochester",
  "03840": "Greenland",
  "03841": "Hampstead",
  "03842": "Hampton",
  "03843": "Hampton",
  "03844": "Hampton Falls",
  "03845": "Intervale",
  "03846": "Jackson",
  "03847": "Kearsarge",
  "03848": "Kingston",
  "03849": "Madison",
  "03850": "Melvin Village",
  "03851": "Milton",
  "03852": "Milton Mills",
  "03853": "Mirror Lake",
  "03854": "New Castle",
  "03855": "New Durham",
  "03856": "Newfields",
  "03857": "Newmarket",
  "03858": "Newton",
  "03859": "Newton Junction",
  "03860": "North Conway",
  "03861": "Lee",
  "03862": "North Hampton",
  "03864": "Ossipee",
  "03865": "Plaistow",
  "03866": "Rochester",
  "03867": "Rochester",
  "03868": "Rochester",
  "03869": "Rollinsford",
  "03870": "Rye",
  "03871": "Rye Beach",
  "03872": "Sanbornville",
  "03873": "Sandown",
  "03874": "Seabrook",
  "03875": "Silver Lake",
  "03878": "Somersworth",
  "03882": "Effingham",
  "03883": "South Tamworth",
  "03884": "Strafford",
  "03885": "Stratham",
  "03886": "Tamworth",
  "03887": "Union",
  "03890": "West Ossipee",
  "03894": "Wolfeboro",
  "03896": "Wolfeboro Falls",
  "03897": "Wonalancet",
};
